/**
 * Position classes for the slideshow's logo, close button and counter in each
 * screen corner. The default corner of each keeps the classes it always had.
 * Classes are written out in full so Tailwind finds them.
 */

const LOGO = {
    tl: 'top-[22px] left-[1.6em]',
    tr: 'top-[22px] right-[1.6em]',
    bl: 'bottom-[22px] left-[1.6em]',
    br: 'bottom-[22px] right-[1.6em]',
};

const PHONE_LOGO = {
    tl: 'top-5 left-5',
    tr: 'top-5 right-5',
    bl: 'bottom-5 left-5',
    br: 'bottom-5 right-5',
};

const CLOSE = {
    tl: 'top-0 left-0',
    tr: 'top-0 right-0',
    bl: 'bottom-0 left-0',
    br: 'bottom-0 right-0',
};

const COUNTER = {
    tl: 'top-[20px] md:top-[19px] left-[20px] md:left-[30px]',
    tr: 'top-[20px] md:top-[19px] right-[20px] md:right-[30px]',
    bl: 'bottom-[20px] md:bottom-[19px] left-[20px] md:left-[30px]',
    br: 'bottom-[20px] md:bottom-[19px] right-[20px] md:right-[30px]',
};

const TABLES = { logo: LOGO, phoneLogo: PHONE_LOGO, close: CLOSE, counter: COUNTER };
const DEFAULT_CORNER = { logo: 'tl', phoneLogo: 'tl', close: 'tr', counter: 'br' };

/** Position classes for `kind` in `corner`; an unknown corner takes the default one. */
export function chromeCornerClass(kind, corner) {
    const table = TABLES[kind];
    if (!table) return '';
    return table[corner] || table[DEFAULT_CORNER[kind]];
}
